import './PulsatingDot.css';

export interface PulsatingDotProps {
  title: string;
}

const PulsatingDot = ({ title }: PulsatingDotProps) => (
  <div className="ring-container" title={title}>
    <div className="ringring" />
    <div className="circle" />
  </div>
);

export default PulsatingDot;
